export const comments_5053769 = {"data":{"data":[],"links":{}}}